// @ts-nocheck
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import ProductArtSelection, { ProductArtSelectionStyles } from "@store/Library/Components/ProductArtSelection";
import React from "react";

export const artSelectionStyles: ProductArtSelectionStyles = {};

const ProductDetailsArtSelection: React.FC = () => {
    return <ProductArtSelection extendedStyles={artSelectionStyles} />;
};

const widgetModule: WidgetModule = {
    component: ProductDetailsArtSelection,
    definition: {
        displayName: "ArtSelection",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
